module.exports = __webpack_public_path__ + "img/dianxin5-3.8529a53f.jpg";